import React, { useEffect, useMemo } from 'react';
import { useThemes, useTranslation, useBaseAppConfig } from '@core/hooks';

// components
import SingleCard from './SingleCard/SingleCard';
import LoginForm from './LoginForm/LoginForm';

const NotAuthenticatedContent = () => {
  const { isDark } = useThemes();

  const config = useBaseAppConfig();

  const { t } = useTranslation();

  useMemo(() => {
    const description = document.querySelector('.description');
    if (!isDark && description) {
      description.classList.add('description--light');
    }
  }, [isDark]);

  useEffect(() => {
    const description = document.querySelector('.description');
    if (!isDark && description) {
      description.classList.add('description--light');
    }
  }, []);

  const determineWrapperClassName = () => {
    let wrapperClassName = 'not-authenticated-content';

    if (config.authApiUrl?.includes('test')) {
      wrapperClassName += ' not-authenticated-content__test';
    }

    return wrapperClassName;
  };

  return (
    <section className={determineWrapperClassName()}>
      <SingleCard title={(config.title as string | undefined) || ''}>
        <p className={`description ${!isDark ? 'description--light' : ''}`}>
          {t('NewUser')}
        </p>
        <LoginForm />
      </SingleCard>
    </section>
  );
};

export default NotAuthenticatedContent;
